export default "__VITE_ASSET__f544a36c__"